import React from 'react';
import { Outlet, NavLink } from 'react-router-dom';
import './CourseNavigationLayout.css';

const CourseNavigationLayout = () => {
  return (
    <div className="mcn-container">
      {/* Navigation Header */}
      <div className="mcn-nav-header">
        <div className="mcn-nav-container">
          <nav className="mcn-nav-tabs">
            <ul>
              <li>
                <NavLink
                  to="/my-courses/mycourses"
                  className={({ isActive }) => 
                    isActive ? "mcn-nav-tab mcn-nav-tab-active" : "mcn-nav-tab"
                  }
                >
                  My Courses
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/my-courses/mylearningpath"
                  className={({ isActive }) => 
                    isActive ? "mcn-nav-tab mcn-nav-tab-active" : "mcn-nav-tab"
                  }
                >
                  My Learning Paths
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/my-courses/trainingvideos"
                  className={({ isActive }) => 
                    isActive ? "mcn-nav-tab mcn-nav-tab-active" : "mcn-nav-tab"
                  }
                >
                  Training Videos
                </NavLink>
              </li>
            </ul>
          </nav>
        </div>
      </div>

      {/* Content Area */}
      <div className="mcn-main-content">
        <Outlet />
      </div>
    </div>
  );
};

export default CourseNavigationLayout;